<template>
    <el-dialog class="dialogContent" width="800px" v-model="dialogVisible" :title="listItem.title" :before-close="handleClose">
        <el-scrollbar max-height="500px">
            <div class="text" v-html="listItem.content"></div>
        </el-scrollbar>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false">退出</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
// import { ElMessageBox } from 'element-plus'

const dialogVisible = ref(false)
const props = defineProps({
    isShow: {
        type: Boolean,
        required: true
    },
    listItem: {
        type: Object,
        required: true
    }
})

const emits = defineEmits(['getDetail'])
emits('getDetail', dialogVisible)

watch(
    () => props.isShow,
    (newval) => {
        dialogVisible.value = newval
    },
    {
        immediate: true
    }
)
const handleClose = () => {
    dialogVisible.value = false
    // ElMessageBox.confirm('您确定要推出查看公告吗?').then(() => {

    // })
}
</script>
<style scoped lang="scss">
.dialog-footer button:first-child {
    margin-right: 10px;
}
:deep(.el-overlay-dialog) {
    width: 500px;
}
.content {
    display: flex;
    margin-bottom: 10px;
    max-height: 500px;
    .title {
        width: 70px;
        font-size: 14px;
    }
    .text {
        flex: 1;
        max-height: 500px;
        overflow: auto;
        :deep(p) {
            line-height: 30px;
        }
    }
}
</style>
